<template>
  <div>
    <div class="ariticle-title">
      <span>投资者和交易者</span>
    </div>
    <div class="ariticle-subtitle">
      <span>2021 年 1 月 31 日更新</span>
      <span></span>
    </div>
    <div class="ariticle-content">
      <p><b>什么是投资者？</b></p>
      <p>
      投资者是指任何个人或其他实体（如公司或共同基金），通过投入资本来获得财务回报。
      投资者依靠不同的金融工具来获得回报率并实现重要的财务目标，这些金融工具包括（但不限于）股票、债券、商品、共同基金、交易所交易基金(ETF)、期权、期货、外汇、黄金、白银、退休计划和房地产。
      投资者可以从不同的角度分析机会，一般更倾向于在最大化收益的同时将风险最小化。
      </p>
      <br>
      <p><b>什么是交易者？</b></p>
      <p>
      交易者是在任何金融市场上为自己或代表其他人或机构从事金融资产买卖的个人。交易者和投资者之间的主要区别在于该人持有资产的期限。投资者倾向于拥有较长的时间范围，而交易者倾向于持有较短的资产以利用短期趋势。
      </p>
      <br>
      <p><b>投资者和交易者有什么区别？</b></p>
      <p>
      投资者通常不同于交易者。投资者将资金用于长期收益，而交易者则通过一遍又一遍地买卖证券来寻求产生短期利润。
      有些投资者通常持有头寸数月数年，而交易者通常持有头寸的时间较短，例如，日内超短线交易者持仓或许只有几分钟，此外，波段交易者持仓可能只有数天到数周。
      </p>
      <br>
      <img src='/imgs/investortrader.png'/>
      <br>
      <br>
      <p><b>被动投资者 PK 主动投资者？</b></p>
      <p>
      投资者建立投资组合时，要么采用试图超越基准指数的主动导向，要么采用试图追踪指数的被动策略。
      被动投资者倾向于购买并持有各种市场指数的成分，并可能根据现代投资组合理论(MPT) 均值方差优化等规则优化其对某些资产类别的分配权重。
      被动（指数）投资正变得越来越流行，它正在取代主动投资策略成为占主导地位的股票市场逻辑。交易所交易基金和机器人顾问的增长是这种受欢迎程度飙升的部分原因。
      </p>
      <br>
      <br>
      <p>
        <i>关键词</i>
      </p>
      <p>
        <i>investor 投资者, trader 交易者, financial instruments 金融工具, long-term gain长期收益, short-term profits短期收益, portfolios 投资组合
          institutional investors 机构投资者, individual investors 个人投资者, scalp traders 头皮交易者, swing investors 波段交易者, passive investors 被动投资者, active investors 主动投资者
        </i>
      </p>
      <p>
        <i>investor 投资者, trader 交易者, financial instruments 金融工具, long-term gain长期收益, short-term profits短期收益, portfolios 投资组合
          institutional investors 机构投资者, individual investors 个人投资者, scalp traders 头皮交易者, swing investors 波段交易者, passive investors 被动投资者, active investors 主动投资者
        </i>
      </p>
      <p>
        <i>investor 投资者, trader 交易者, financial instruments 金融工具, long-term gain长期收益, short-term profits短期收益, portfolios 投资组合
          institutional investors 机构投资者, individual investors 个人投资者, scalp traders 头皮交易者, swing investors 波段交易者, passive investors 被动投资者, active investors 主动投资者
        </i>
      </p>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
</style>
